import type { CircleImageCardData } from "../types";

export function CircleImageCard({ data }: { data: CircleImageCardData }) {
	return (
		<div className="group border-ivory/5 bg-dark-accent hover:border-gold/30 relative z-10 overflow-hidden border p-6 transition-all duration-500">
			<div className="border-gold/20 mx-auto mb-8 aspect-square max-w-[180px] overflow-hidden rounded-full border">
				<img
					alt={data.imageAlt}
					className="h-full w-full scale-110 object-cover grayscale transition-all duration-700 hover:grayscale-0"
					src={data.imageSrc}
				/>
			</div>
			<span className="text-gold mb-3 block text-center text-[10px] font-medium tracking-widest uppercase">
				{data.category}
			</span>
			<h2 className="font-display mb-4 text-center text-2xl leading-snug">
				{data.title}
			</h2>
			<p className="text-ivory/60 text-center text-xs leading-relaxed font-light">
				{data.description}
			</p>
		</div>
	);
}
